import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75984 4H4V8.75984H5.87V5.87H8.75971L8.75984 4Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M8.75984 20.9995H4V16.2393H5.87V19.1292H8.75971L8.75984 20.9995Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M16.2401 4H21V8.75984H19.13V5.87H16.2402L16.2401 4Z"
      fill={props.color || 'currentColor'}
    />
    <path
      d="M16.2401 20.9995H21V16.2393H19.13V19.1292H16.2402L16.2401 20.9995Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgWidthAndHeightOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgWidthAndHeightOutline;
